import React from 'react';
import * as S from './Card.styles';

import HotelDetail from '../HotelDetail/HotelDetail';
import RoomDetail from '../HotelRoomDetail/HotelRoomDetail';
import Links from '../Links/Links';

const ThankYouCard = ({hotelDetails, roomDetails, checkinCheckoutDetail,
    guestDetails, priceInfo, fareBreakup, actions,status}) => (
  <S.BookedHotelInfoOuterWrap>
    <HotelDetail details={hotelDetails} guestDetails={guestDetails} checkinCheckoutDetail={checkinCheckoutDetail} />
    <RoomDetail details={roomDetails} priceInfo={priceInfo} fareBreakup={fareBreakup} />
    {(actions.length && <Links actions={actions} status={status}/>) || null}
  </S.BookedHotelInfoOuterWrap>
);

export default ThankYouCard;
